import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=96a63be6&"
import script from "./EventList.vue?vue&type=script&lang=js&"
export * from "./EventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96a63be6')) {
      api.createRecord('96a63be6', component.options)
    } else {
      api.reload('96a63be6', component.options)
    }
    module.hot.accept("./EventList.vue?vue&type=template&id=96a63be6&", function () {
      api.rerender('96a63be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/EventList.vue"
export default component.exports